import React from 'react';
import { motion } from 'framer-motion';
import { EditorialLayout } from '../components/EditorialLayout';
export function Updates() {
  const updates = [{
    title: 'Scaling Without Shrinking the World',
    summary: 'Natalya Wallin explores how we can scale innovation without depleting the systems we depend on — a case for nature-aligned growth.',
    tag: 'Thought Leadership',
    link: 'https://www.linkedin.com/pulse/scaling-without-shrinking-world-natalya-wallin-ci3bc/?trackingId=Y4e%2Fce8CapwFGB96to571g%3D%3D',
    color: '#edcd99'
  }, {
    title: 'Vitality featured in USA Today',
    date: 'November 3, 2024',
    summary: "It's time to rethink what and who we fund, says Vitality founder Natalya Wallin.",
    tag: 'Press',
    link: 'https://www.usatoday.com/story/special/contributor-content/2025/11/03/its-time-to-rethink-what-and-who-we-fund-says-vitality-founder-natalya-wallin/87064743007/',
    color: '#78e1c4'
  }, {
    title: 'Vitality Founder Profiled in International Business Times',
    date: 'July 25, 2025',
    summary: "Natalya Wallin discusses the future of biomimicry in venture capital and Vitality's unique thesis.",
    tag: 'Press',
    link: 'https://www.ibtimes.com/vitality-vision-natalya-wallins-full-circle-journey-investing-nature-inspired-innovation-3779469',
    color: '#78e1c4'
  }, {
    title: 'Co-hosts first Vital Systems event in NYC',
    date: 'July 22, 2025',
    summary: 'Partnership with GrantMatch, REFASHIOND Ventures, and American Australian Association.',
    tag: 'Event',
    color: '#4DE7D4'
  }, {
    title: 'Vitality GP Natalya Wallin interviewed for CEO Weekly',
    date: 'November 2024',
    summary: 'How Natalya Wallin and Vitality are betting on nature to solve modern problems.',
    tag: 'Press',
    link: 'https://ceoweekly.com/the-next-big-wave-in-tech-is-ancient-how-natalya-wallin-and-vitality-are-betting-on-nature-to-solve-modern-problems/',
    color: '#78e1c4'
  }, {
    title: 'Emergent Campus Partnership',
    summary: 'Connecting with the Emergent Campus community — a hub for regenerative innovation and interdisciplinary collaboration.',
    tag: 'Partnership',
    link: 'https://emergentcampus.org/about-us/',
    color: '#a0e6e9'
  }, {
    title: 'Collaboration with ASU Biomimicry Center',
    date: 'September 23, 2024',
    summary: 'Pilot program supporting faculty and student ventures in biomimicry solutions.',
    tag: 'Partnership',
    color: '#edcd99'
  }, {
    title: 'Vitality Invests in ReefCycle',
    date: 'April 21, 2024',
    summary: 'Announcement of investment in nature-based cement startup from Ray of Hope Accelerator.',
    tag: 'Investment',
    color: '#a0e6e9'
  }];
  // Generate more prominent raindrop paths
  const raindrops = Array.from({
    length: 50
  }, (_, i) => ({
    x: i * 2 % 100,
    duration: 2.5 + Math.random() * 3,
    delay: Math.random() * 6,
    opacity: 0.3 + Math.random() * 0.4,
    width: 1.5 + Math.random() * 2.5
  }));
  return <div className="min-h-screen pt-20 relative overflow-hidden bg-[#0e2533]" data-id="element-1754">
      {/* Hero Section */}
      <section aria-label="Vitality news, press, and events" className="relative py-24 overflow-hidden" data-id="element-1755">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0e2533] via-[#1c3f4d] to-[#0e2533] z-0" data-id="element-1756" />
        <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/gtLophfUWLMDJAhzzeZCTa/AdobeStock_1646415265.jpg')] bg-cover bg-center opacity-50" data-id="element-1757" />
        <div className="absolute inset-0 bg-carbonBlack/40" data-id="element-1758" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1759">
          <motion.h1 initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} className="text-5xl md:text-7xl font-bold text-white" data-id="element-1760">
            UPDATES
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-xl text-vitalityTeal mt-4" data-id="element-1761">
            Following the flow of our journey
          </motion.p>
        </div>
      </section>

      {/* Content Section with Enhanced Raindrop & Ripple Animations */}
      <section className="py-16 min-h-screen relative" data-id="element-1762">
        {/* Prominent raindrop trails running down the page */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-40" data-id="element-1763">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-1764">
            <defs data-id="element-1765">
              <linearGradient id="raindropGradient" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-1766">
                <stop offset="0%" stopColor="#78e1c4" stopOpacity="0" data-id="element-1767" />
                <stop offset="20%" stopColor="#78e1c4" stopOpacity="0.9" data-id="element-1768" />
                <stop offset="60%" stopColor="#4DE7D4" stopOpacity="0.7" data-id="element-1769" />
                <stop offset="100%" stopColor="#78e1c4" stopOpacity="0" data-id="element-1770" />
              </linearGradient>
              <filter id="dropGlow" data-id="element-1771">
                <feGaussianBlur stdDeviation="2" result="blur" data-id="element-1772" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" data-id="element-1773" />
              </filter>
            </defs>

            {/* Vertical raindrop trails - more prominent */}
            {raindrops.map((drop, i) => <motion.line key={`rain-${i}`} x1={`${drop.x}%`} y1="0%" x2={`${drop.x}%`} y2="100%" stroke="url(#raindropGradient)" strokeWidth={drop.width} strokeLinecap="round" filter="url(#dropGlow)" initial={{
            pathLength: 0,
            opacity: 0
          }} animate={{
            pathLength: [0, 0.4, 0],
            opacity: [0, drop.opacity, 0],
            y: ['0%', '100%']
          }} transition={{
            duration: drop.duration,
            repeat: Infinity,
            ease: 'easeIn',
            delay: drop.delay
          }} data-id="element-1774" />)}
          </svg>
        </div>

        {/* Enhanced raindrop particles cascading down */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-1775">
          {Array.from({
          length: 60
        }).map((_, i) => {
          const startX = Math.random() * 100;
          const size = 3 + Math.random() * 6;
          const duration = 3 + Math.random() * 3;
          return <motion.div key={`droplet-${i}`} className="absolute rounded-full" style={{
            left: `${startX}%`,
            width: `${size}px`,
            height: `${size * 2.5}px`,
            background: 'linear-gradient(180deg, rgba(120, 225, 196, 0.8) 0%, rgba(77, 231, 212, 0.5) 50%, transparent 100%)',
            filter: 'blur(1.5px)',
            boxShadow: '0 0 8px rgba(120, 225, 196, 0.4)'
          }} animate={{
            y: ['-10vh', '110vh'],
            opacity: [0, 1, 1, 0]
          }} transition={{
            duration,
            repeat: Infinity,
            ease: 'easeIn',
            delay: Math.random() * 6
          }} data-id="element-1776" />;
        })}
        </div>

        {/* More prominent water ripple effect */}
        <div className="absolute inset-0 pointer-events-none opacity-25" data-id="element-1777">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-1778">
            <defs data-id="element-1779">
              <radialGradient id="ripple" data-id="element-1780">
                <stop offset="0%" stopColor="#78e1c4" stopOpacity="0.8" data-id="element-1781" />
                <stop offset="50%" stopColor="#4DE7D4" stopOpacity="0.4" data-id="element-1782" />
                <stop offset="100%" stopColor="#78e1c4" stopOpacity="0" data-id="element-1783" />
              </radialGradient>
            </defs>
            {Array.from({
            length: 10
          }).map((_, i) => <motion.circle key={`ripple-${i}`} cx={`${15 + i * 10}%`} cy={`${25 + i % 3 * 25}%`} r="0" fill="url(#ripple)" animate={{
            r: [0, 200, 0],
            opacity: [0, 0.6, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeOut',
            delay: i * 0.8
          }} data-id="element-1784" />)}
          </svg>
        </div>

        {/* Additional splash effects */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-20" data-id="element-1785">
          {Array.from({
          length: 15
        }).map((_, i) => {
          const x = Math.random() * 100;
          const y = Math.random() * 100;
          return <motion.div key={`splash-${i}`} className="absolute w-3 h-3 rounded-full bg-vitalityTeal" style={{
            left: `${x}%`,
            top: `${y}%`,
            filter: 'blur(2px)'
          }} animate={{
            scale: [0, 2, 0],
            opacity: [0, 0.8, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeOut',
            delay: Math.random() * 5
          }} data-id="element-1786" />;
        })}
        </div>

        {/* Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1787">
          {/* In Action - Professional Engagements */}
          <div className="mb-16" data-id="element-1788">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-1789">
              In Action
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gray-400 mb-8" data-id="element-1790">
              Speaking, presenting, and building the next generation
            </motion.p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1791">
              {[{
              src: 'https://cdn.magicpatterns.com/uploads/9tG6ECG63FkmLaWdBg39pR/Speaking.jpg',
              caption: 'Speaking at Vital Systems event in New York City',
              tag: 'NYC Panel'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/2yQvqxAAcgq5iq9oidEbTo/biomimicry_slide.jpg',
              caption: "Presenting on biomimicry and nature's 3.8 billion year R&D lab",
              tag: 'Keynote'
            }, {
              src: 'https://cdn.magicpatterns.com/uploads/fqrXvdy8gm6KefinQxY9KQ/Vitality_Duke_students.jpg',
              caption: 'Hosting the next generation of innovators — Duke University students',
              tag: 'Mentorship'
            }].map((photo, i) => <motion.div key={photo.tag} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.15,
              duration: 0.5
            }} className="group relative rounded-2xl overflow-hidden bg-[#1c3f4d]/40 border border-white/10" data-id="element-1792">
                  <div className="aspect-[4/3] overflow-hidden" data-id="element-1793">
                    <img src={photo.src} alt={photo.caption} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1794" />
                  </div>
                  <div className="p-4 sm:p-5" data-id="element-1795">
                    <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border uppercase tracking-wider text-vitalityTeal border-vitalityTeal/30 bg-vitalityTeal/10 mb-3" data-id="element-1796">
                      {photo.tag}
                    </span>
                    <p className="text-gray-300 text-sm leading-relaxed" data-id="element-1797">
                      {photo.caption}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          <EditorialLayout updates={updates} data-id="element-1798" />
        </div>
      </section>
    </div>;
}